import { useCallback, useEffect, useMemo, useRef } from 'react';

import { DialogKey } from '#src/components/navigation/WithDialogs/index.tsx';
import { JonumRewardGateContext } from '#src/contexts/jonumRewardGate/index.ts';
import { useOpenDialog } from '#src/hooks/navigation/useOpenDialog.ts';

import {
  JONUM_REWARD_GATE_DIALOG_PARAM,
  useJonumVerificationGuard,
} from '../JonumVerificationDialog/useJonumVerificationGuard.ts';

type Props = {
  children: React.ReactNode;
};

export const JonumRewardGateProvider = ({ children }: Props) => {
  const { shouldShow, kycRequired, kycUnderReview } = useJonumVerificationGuard(
    { openedByGate: true }
  );
  const openDialog = useOpenDialog();

  const latest = useRef({
    shouldShow,
    kycRequired,
    kycUnderReview,
    openDialog,
  });
  useEffect(() => {
    latest.current = { shouldShow, kycRequired, kycUnderReview, openDialog };
  }, [shouldShow, kycRequired, kycUnderReview, openDialog]);

  const openJonumRewardGate = useCallback(() => {
    const gate = latest.current;
    const verificationOwed =
      gate.shouldShow || (gate.kycRequired && !gate.kycUnderReview);
    if (!verificationOwed) {
      return false;
    }

    gate.openDialog(
      DialogKey.jonumVerification,
      JONUM_REWARD_GATE_DIALOG_PARAM
    );
    return true;
  }, []);

  const value = useMemo(() => ({ openJonumRewardGate }), [openJonumRewardGate]);

  return (
    <JonumRewardGateContext.Provider value={value}>
      {children}
    </JonumRewardGateContext.Provider>
  );
};
